import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircleTwoTone } from '@ant-design/icons';
import { jsPDF } from 'jspdf';
import './typeFo/Roboto-Regular-normal';
import axios from "axios";
import { API_BASE_URL } from '../../utils/BaseUrl';

const SaveAsPDF = (bill) => {
  const user = JSON.parse(localStorage.getItem('user'))?.fullname || 'Khách hàng';
  const doc = new jsPDF();
  doc.setFont('Roboto-Regular');
  doc.setFontSize(16);
  doc.text('HÓA ĐƠN THANH TOÁN', 20, 20);
  doc.setFontSize(12);
  doc.text(`Phòng gym ID: ${bill.gymId}`, 20, 35); // Hiện chỉ có gymId
  doc.text(`Mã đơn hàng: ${bill.orderCode}`, 20, 45);
  doc.text(`Ngày thanh toán: ${bill.date}`, 20, 55);
  doc.text(`Khách hàng: ${bill.customerName}`, 20, 65);
  doc.text(`Mô tả: ${bill.description}`, 20, 75);
  doc.text(`Phương thức thanh toán: ${bill.paymentMethod}`, 20, 85);
  doc.text(`Tổng tiền: ${bill.amount.toLocaleString('vi-VN')} VNĐ`, 20, 95);
  doc.save(`HoaDon-${bill.orderCode}.pdf`);
};
window.SaveAsPDF = SaveAsPDF;

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderCode = params.get("orderCode");


  const [bill, setBill] = useState(null);

  useEffect(() => {
    if (!orderCode) return;

    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/PaymentGymPackage/by-order-code?orderCode=${orderCode}`);
        const data = await response.json();

        setBill({
          orderCode: data.orderCode,
          amount: data.amount,
          description: `Gói ${data.packageName}`,
          date: new Date(data.createdAt).toLocaleString('vi-VN'),
          customerName: data.userName || 'Khách hàng',
          paymentMethod: 'PayOS - QR Code',
          gymId: data.gymId
        });
      } catch (error) {
        console.error("Lỗi khi lấy dữ liệu hóa đơn:", error);
      }
    };

    const confirmPayment = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await axios.post(
          `${API_BASE_URL}/api/PaymentGymPackage/confirm-payment`,
          null,
          {
            params: { orderCode }
          }
        );

        console.log("✅ Thanh toán đã được xác nhận!", res.data);

        const updatedUser = { ...user, role: "GymOwner" };
        localStorage.setItem("user", JSON.stringify(updatedUser));

        if (!sessionStorage.getItem("hasReloaded")) {
          sessionStorage.setItem("hasReloaded", "true");
          window.location.reload();
        }
      } catch (error) {
        console.error("❌ Xác nhận thanh toán thất bại:", error.response?.data || error.message);
      }
    };

    

    fetchData();
    confirmPayment();
  }, [orderCode,]);

  if (!bill) return <div>Đang tải hóa đơn...</div>;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #fffbe7 0%, #ffe0b2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 8px 32px #ff980033',
        width: 400,
        maxWidth: '95vw',
        padding: 32,
        border: '1.5px solid #ffe0b2',
        fontFamily: 'Montserrat, Arial, sans-serif',
        position: 'relative'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 48 }} />
        </div>
        <h2 style={{
          textAlign: 'center',
          color: '#FF9800',
          marginBottom: 0,
          fontWeight: 700,
          letterSpacing: 1
        }}>THANH TOÁN THÀNH CÔNG</h2>
        <div style={{ textAlign: 'center', color: '#888', fontSize: 15, marginBottom: 18 }}>
          Gym ID: {bill.gymId}
        </div>
        <div style={{ borderTop: '1.5px dashed #ff9800', margin: '16px 0 12px 0' }} />

        <div style={{ marginBottom: 10, fontSize: 15 }}><strong>Mã đơn hàng:</strong><span style={{ float: 'right', fontFamily: 'monospace', color: '#FF9800' }}>{bill.orderCode}</span></div>
        <div style={{ marginBottom: 10, fontSize: 15 }}><strong>Ngày thanh toán:</strong><span style={{ float: 'right' }}>{bill.date}</span></div>
        <div style={{ marginBottom: 10, fontSize: 15 }}><strong>Khách hàng:</strong><span style={{ float: 'right' }}>{bill.customerName}</span></div>
        <div style={{ marginBottom: 10, fontSize: 15 }}><strong>Gói dịch vụ:</strong><span style={{ float: 'right' }}>{bill.description}</span></div>
        <div style={{ marginBottom: 10, fontSize: 15 }}><strong>Phương thức:</strong><span style={{ float: 'right' }}>{bill.paymentMethod}</span></div>

        <div style={{ borderTop: '1.5px dashed #ff9800', margin: '18px 0 12px 0' }} />

        <div style={{ fontSize: 22, fontWeight: 700, color: '#388e3c', textAlign: 'center', letterSpacing: 1, marginBottom: 8 }}>
          Tổng tiền: <span style={{ color: '#d32f2f', fontSize: 26 }}>{bill.amount.toLocaleString()} VND</span>
        </div>
        <div style={{ textAlign: 'center', fontStyle: 'italic', color: '#888', marginTop: 18, fontSize: 15 }}>
          Cảm ơn bạn đã sử dụng dịch vụ 💪
        </div>
        <div style={{ textAlign: 'center', marginTop: 24, display: 'flex', justifyContent: 'center', gap: 16 }}>
          <button onClick={() => navigate('/')} style={{ background: '#FF9800', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 28px', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Về trang chủ</button>
          <button onClick={() => window.SaveAsPDF(bill)} style={{ background: '#388e3c', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 28px', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Xuất hóa đơn</button>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
